import { connect } from 'react-redux';
import type { Action, Dispatch } from 'redux';

import type { RootReducerStateT } from 'app/reducers/rootReducer';
import { actions as telephonyActions } from 'components/settings/actions/telephony';
import { TelephonyState } from 'components/settings/reducers/sections/telephony';
import type { GetNumbersByQueryPayloadT } from 'components/telephony/api/types';

import {
  TopbarButtons,
  PropsT as TopBarButtonsProps,
} from '../components/TopbarButtons';

export type TopBarButtonStatePropsT = {
  telephonyState: TelephonyState;
};

export type TopBarButtonDispatchPropsT = {
  getNumbersByQuery: (payload: GetNumbersByQueryPayloadT) => void;
};

const { telephonyGetNumbersByQuery } = telephonyActions;

const mapStateToProps = (state: RootReducerStateT): TopBarButtonStatePropsT => {
  return {
    telephonyState: state.settings.telephony,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    getNumbersByQuery: (payload: GetNumbersByQueryPayloadT) =>
      dispatch(telephonyGetNumbersByQuery(payload)),
  };
};

export default connect<
  TopBarButtonStatePropsT,
  TopBarButtonDispatchPropsT,
  TopBarButtonsProps,
  RootReducerStateT
>(
  mapStateToProps,
  mapDispatchToProps,
)(TopbarButtons);
